// File: DigitalAgencyAboutSection.jsx
// Modern gradient background + video play button + CTA

import { Play } from 'lucide-react';
import React from 'react';

export default function AboutUsCard12() {
  return (<>
    <section className="da-wrap-ac-12">
      <div className="da-left-ac-12">
        <div className="video-card-ac-12">
         
          <button className="play-btn-ac-12"><Play size={30}  color={"#ffffff"}/></button>
             <div className="stat-ac-12s-box-ac-12">
          <div className="stat-ac-12">
            <span className="num-ac-12">50K+</span>
            <p>Global Happy Clients</p>
          </div>
          <div className="stat-ac-12">
            <span className="num-ac-12">16+</span>
            <p>Services</p>
          </div>
          <div className="stat-ac-12">
            <span className="num-ac-12">12+</span>
            <p>Years Experience</p>
          </div>
          <div className="stat-ac-12">
            <span className="num-ac-12">4.5+</span>
            <p>Rating</p>
          </div>
        </div>
        </div>
      </div>

      <div className="da-right-ac-12">
        <h5 className="sup-ac-12">ABOUT US</h5>
        <h2 className="title-ac-12">Best Marketing Agency Service Company Online Today!</h2>
        <h3 className="since-ac-12">Since 1992</h3>

        <p className="text-ac-12">
          Te obtinuit ut adepto satis somno. Aliisque institoribus iter deliciae vivet vita.
          Nam exempli gratia Te obtinuit ut adepto satis somno.
        </p>

        <button className="cta-btn-ac-12">→ More About Us</button>
      </div>
    </section>
    <style>{`
/* File: DigitalAgencyAboutSection.css */

.da-wrap-ac-12 { margin-top:50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px 50px;
  background:linear-gradient(90deg, #ffffff 0%, rgba(144, 202, 249,0.51) 100%);
  font-family: Inter, sans-serif;
}

/* STATS CARD */
.stat-ac-12s-box-ac-12 {
  display: flex;
  gap: 20px;
  background: rgba(144, 202, 249,0.51);
  padding: 22px;
  border-radius: 18px;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.stat-ac-12 { text-align: center; flex: 1; }
.num-ac-12 {
  font-size: 26px;
  font-weight: 800;
  color: #222222;
}
.stat-ac-12 p {
  color: #333333;
  font-size: 13px;
  margin-top: 6px;
}

/* LEFT */
.video-card-ac-12 {min-width: 500px;
  position: relative;min-height:380px;
  border-radius: 20px;
  overflow: hidden;
}

.da-img-ac-12 {
  width: 500px;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
}

.play-btn-ac-12 {
  position: absolute;
  top: 50%;display:flex;justify-content:center;align-items:center;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background:rgba(144, 202, 249,1);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 32px;
  cursor: pointer;
  box-shadow: 0 0 20px rgba(144, 202, 249,0.5);
}

/* RIGHT */
.da-right-ac-12 {
  max-width: 550px;
}

.sup-ac-12 {
  text-ac-12-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}

.title-ac-12 {
  font-size: 34px;
  font-weight: 800;
  margin-bottom: 16px;
  color: #222;
}

.since-ac-12 {
  font-size: 30px;
  font-weight: 800;
  color: rgba(144, 202, 249,1);
  margin-bottom: 20px;
}

.text-ac-12 {
  color: #444;
  line-height: 1.7;
  margin-bottom: 26px;
}

.cta-btn-ac-12 {
  background: rgba(144, 202, 249,1);
  color: #fff;
  padding: 12px 22px;
  border: none;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
}

/* Responsive */
@media(max-width:960px){

/* RIGHT */
.da-right-ac-12 {
 padding: 0px 0px;
}
  .da-wrap-ac-12 {
    flex-direction: column; padding: 20px 10px 0px 0px ;
    text-ac-12-align: center;
    gap: 40px;
  }.video-card-ac-12 {min-width:300px;min-height:300px;
    }
  
.play-btn-ac-12 {
  top: 80%;
 }
  .da-img-ac-12 {
    width: 100%;
  }
  .da-right-ac-12 {
    max-width: 100%;
  }
}
`}</style>
 </> );
}
